module.exports = __webpack_public_path__ + "static/media/email.323d23d8.svg";